export class NodeRegistry {
  constructor() {
    this.registry = new Map();
  }

  register(kind, factory) {
    this.registry.set(kind, factory);
  }

  get(kind) {
    return this.registry.get(kind);
  }

  has(kind) {
    return this.registry.has(kind);
  }
}
